(function () {
  'use strict';
  if (window.TRDEnquiryAttribution) return;
  window.TRDEnquiryAttribution = true;
  var key = 'trd_enquiry_source_v1', maxAge = 30 * 60 * 1000;
  var fields = ['contact[Enquiry source estimate]', 'contact[Search engine]', 'contact[First landing path]'];
  var entry = classify();
  function allowed() {
    try { return window.Shopify.customerPrivacy.analyticsProcessingAllowed() === true; }
    catch (_) { return false; }
  }
  function classify() {
    var params = new URLSearchParams(window.location.search);
    var medium = (params.get('utm_medium') || '').toLowerCase();
    var source = 'direct_or_unknown', engine = '';
    var paid = ['gclid', 'dclid', 'gbraid', 'wbraid', 'msclkid'].some(function (k) { return params.has(k); }) || /^(cpc|ppc|paid|paidsearch|paid_search|paid-social|paid_social)$/.test(medium);
    try {
      var host = new URL(document.referrer).hostname.toLowerCase();
      if (/(^|\.)google\.(com|[a-z]{2}|co\.[a-z]{2}|com\.[a-z]{2})$/.test(host)) engine = 'google';
      else if (/(^|\.)bing\.com$/.test(host)) engine = 'bing';
      else if (/(^|\.)duckduckgo\.com$/.test(host)) engine = 'duckduckgo';
      else if (/(^|\.)search\.yahoo\.com$/.test(host)) engine = 'yahoo';
      else if (/(^|\.)ecosia\.org$/.test(host)) engine = 'ecosia';
      if (host !== window.location.hostname && host !== 'www.' + window.location.hostname) source = engine ? 'organic_search' : 'referral';
    } catch (_) {}
    if (medium === 'organic') source = 'organic_search';
    else if (medium === 'email') source = 'email';
    if (paid) source = 'paid';
    return {source:source, engine:engine, path:window.location.pathname, touched:Date.now()};
  }
  function clean() {
    document.querySelectorAll('#ContactForm [data-trd-source-field]').forEach(function (input) { input.remove(); });
    try { sessionStorage.removeItem(key); } catch (_) {}
  }
  function fill() {
    if (!allowed()) { clean(); return; }
    var value = entry;
    try {
      var old = JSON.parse(sessionStorage.getItem(key) || 'null');
      if (old && ['organic_search','paid','email','referral','direct_or_unknown'].indexOf(old.source) !== -1 && typeof old.path === 'string' && old.path.charAt(0) === '/' && old.path.length < 1024 && Date.now() - old.touched >= 0 && Date.now() - old.touched < maxAge) value = old;
      value.touched = Date.now();
      sessionStorage.setItem(key, JSON.stringify(value));
    } catch (_) {}
    var form = document.getElementById('ContactForm');
    if (!form || !form.querySelector('input[name="form_type"][value="contact"]')) return;
    var values = [value.source, value.engine || 'not_identified', value.path];
    fields.forEach(function (name, i) {
      var input = form.querySelector('[name="'+name+'"]');
      if (!input) { input = document.createElement('input'); input.type = 'hidden'; input.name = name; input.dataset.trdSourceField = 'true'; form.appendChild(input); }
      input.value = values[i];
    });
  }
  function ready() {
    document.addEventListener('visitorConsentCollected', fill);
    document.addEventListener('submit', function (event) { if (event.target.id === 'ContactForm') fill(); }, true);
    if (window.Shopify && window.Shopify.customerPrivacy) fill();
    else if (window.Shopify && window.Shopify.loadFeatures) window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.2'}], function (error) { if (!error) fill(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, {once:true}); else ready();
})();
